/**
 * Kazakan Cognitive Ability Test (IQ Test) Entry Point
 * Pure client-side, zero dependencies, high performance
 */

import { initIqTest } from './iq-test/iq-test-app.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initIqTest('iq-test-app'));
} else {
  initIqTest('iq-test-app');
}
